export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de productores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar productor"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Estás seguro de que deseas eliminar este productor?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos"])},
          "new_crop_field_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo campo"])},
          "destroy_crop_field_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_crop_field_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar campo"])},
          "destroy_crop_field_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Estás seguro de que deseas eliminar este campo?"])},
          "destroy_crop_field_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}